<template>
<div class="relative">
    <div class="fixed white" style="width: 100%;" id="tool-bar">
    <v-row class="ma-0" style="width: 100%;" align="center" justify="start">
		<v-col cols="12" lg="auto" md="6" sm="12" xs="12">
			<slot name="breadcrumbs" :item="true"></slot>
		</v-col>
        <v-col cols="auto" sm="auto" xs="auto" md="6" lg="auto" class="d-flex flex-row justify-start">
            <bee-bond-up-down
                v-model="invoice_no"
                @keydown-enter-prevent="updateRouteId()"
                @programmatically-changed="updateRouteId()"
                :items="simplified_sale_invoices.map(c => c.no)"
                class="medium-placeholder"
                :label="$t('InvoiceSalePage.invoice-no')"
            ></bee-bond-up-down>
        </v-col>
        <v-col cols="12" sm="auto" xs="auto" md="auto" lg="auto" class="d-flex flex-column px-lg-0 justify-center">
			<bee-btn  
				@click="addInvoiceDialog = true"
				:content="$t('InvoiceSalePage.new')"
				color="addingColor"
				context="invoice"
                icon="fa-plus"
				:action-name="actions.CREATE"
                :disabled="file_is_locked"
			></bee-btn>
		</v-col>
        <v-col cols="12" sm="auto" xs="auto" md="auto" lg="auto" class="d-flex flex-column justify-center">
			<bee-btn  
				@click="dialogDeleteInvoice = true"
				:content="$t('InvoiceSalePage.delete')"
				color="deletingColor"
				context="invoice"
                icon="fa-trash"
				:action-name="actions.DELETE"
                :disabled="file_is_locked"
			></bee-btn>
		</v-col>

        <v-spacer/>
        <v-col cols="auto">
            <v-menu offset-y>
                <template v-slot:activator="{ attr, on }">
                    <v-btn dark color="alert-color" v-on="on" v-bind="attr">
                        <v-icon class="me-1">mdi-export-variant</v-icon>
                        {{$t('exports.export')}}
                    </v-btn>
                </template>

                <v-list nav dense>
                    <v-list-item @click="getReport('pdf')">
                        <v-list-item-icon class="me-4">
                            <v-icon>mdi-printer</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{$t('exports.export-as-pdf')}}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="false" @click="getReport('excel')">
                        <v-list-item-icon class="me-4">
                            <v-icon>mdi-microsoft-excel</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{$t('exports.export-as-excel')}}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-col>
    </v-row>
    <v-layout class="mx-3 mb-3 my-border rounded-lg d-flex flex-row wrap" align="center">
        <v-col cols="auto" lg="3" md="auto" sm="auto" xs="auto" class="pb-0 pe-lg-0 d-flex flex-column">
            <bee-account-autocomplete
            :disabled="sale_invoice.is_posted || file_is_locked"
            context="invoice"
            :action-name="actions.EDIT"
            :hide-details="false" 
            :rules="[rules.required]"
            :label="$t('InvoiceSalePage.account')"
            color="primary"
            v-model="sale_invoice.external_account_id"
            :items="configs.accounts.filter(c=>c.type == 2)"
            @change="update()"
            :with-balance="true"
            ></bee-account-autocomplete>
        </v-col>
        <v-col cols="auto" lg="auto" md="auto" sm="auto" xs="auto" class="pb-0 pb-lg-0 d-flex flex-column">
        <bee-date-picker
            :disabled="sale_invoice.is_posted || file_is_locked"
            context="invoice"
            :action-name="actions.EDIT"
            @blur="update()"
            :label="$t('InvoiceSalePage.invoice-date')"
            v-model="sale_invoice.date"
            :rules="[rules.date]"
            :hide-details="false"
        ></bee-date-picker>
        </v-col>
        <v-col cols="12" sm="auto" xs="auto" md="auto" lg="2" class="d-flex flex-column pb-lg-0 pb-0 ps-lg-0">
            <bee-autocomplete 
            :disabled="sale_invoice.is_posted || file_is_locked"
            context="invoice"
            :action-name="actions.GET"
            item-text="name"
            :item-value="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id'"
            :label="$t('InvoiceSalePage.warehouse')"
            :items="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? warehousesForKeeper : warehouses"
            v-model="default_warehouse_id"
            :clearable="false"
            :hide-details="false"
            @change="changeWarehouse()"
            ></bee-autocomplete>
        </v-col>
        <v-col cols="auto" lg="auto" md="auto" sm="auto" xs="auto" class="pb-0 pb-lg-0 px-md-0 d-flex flex-column">
            <bee-text-field
                :disabled="sale_invoice.is_posted || file_is_locked"
                context="invoice"
                :action-name="actions.EDIT"
                @change="update()"
                style="width: 100px !important"
                :label="$t('InvoiceSalePage.document')"
                :hide-details="false"
                :rules="[rules.required]"
                v-model="sale_invoice.doc_no"
            ></bee-text-field>
        </v-col>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-col  v-if="!isWarehousePermission" cols="auto" lg="auto" md="auto" sm="auto" xs="auto" class="pb-lg-0 pt-lg-1 d-flex flex-column">
            <bee-outlined-header-info
                :head="$t('InvoiceSalePage.net-invoice')"
                style="line-height: 1.5rem;"
                border-color="transparent"
                class="pa-lg-0"
                :column="on_lgAndUp"
            >
                <template  v-slot:content="{}">
                    <bee-money-label :number="total_net" type="credit" :withColor="true" empty-state="_"></bee-money-label>
                </template>
            </bee-outlined-header-info>
        </v-col>
        <!-- invoice posting progress circular -->
        <v-col cols="auto" class="d-flex justify-lg-end py-1">
            <router-link style="text-decoration: none;" :to="{name: 'invoices', query: { type: 2 }}">
                <bee-progress-circular
                    :size="60"
                    :width="6"
                    :title="bond_posting_ratio_caption"
                    :value="bond_posting_ratio"
                    :tooltip="bond_posting_ratio_tooltip"
                ></bee-progress-circular>
            </router-link>
        </v-col>
        
        <v-col  v-if="!isWarehousePermission" cols="auto" sm="auto" xs="auto" md="auto" lg="auto" class="d-flex flex-column py-lg-0 ps-lg-0">
            <bee-btn context="invoice" :action-name="actions.EDIT" 
                :icon="sale_invoice.is_posted ? 'fa-envelope-open' : 'fa-envelope'"
                :outer-class="on_lgAndUp ? 'fill-height text-wrap' : ''" 
                :content="sale_invoice.is_posted ? $t('InvoiceSalePage.edit') : $t('InvoiceSalePage.save')"
                :disabled="file_is_locked"
                :loading="updateInvoiceLoading" 
                :color="sale_invoice.is_posted ? 'deletingColor' : 'blueGray'" 
                @click="sale_invoice.is_posted ? unPosting() : posting()">
            </bee-btn>
        </v-col>
        <v-col cols="12" sm="12" xs="12" md="12" lg="1" 
            class="d-flex flex-column align-center pa-lg-0"
            :class="[
                sale_invoice.is_posted ? 'postedColor' : 'unpostedColor',
                on_lgAndUp ? 'border-round-end' : 'border-round-bottom'
            ]"
        >
            <span class="d-flex justify-center text-center align-center fill-height text-wrap white--text font-weight-bold">{{sale_invoice.is_posted ? '' : $t('InvoiceSalePage.not')}}
                {{$t('InvoiceSalePage.posted')}}
            </span>
        </v-col>
    </v-layout>
    </div>
    <div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
    <v-row style="width: 100%;" class="ma-0 px-3">
        <bee-smart-table v-model="tableInputs" mode="materials" context="invoice" :action-name="actions.CREATE" ref="table" :with-color="false" :zebra="true" empty-state="dashes" :hide-footer="true"
            @cell-change="entries[$event.index][$event.header.value] = $event.value"
            :addable="addable && !file_is_locked" :editable="!sale_invoice.is_posted && !file_is_locked" :configs="[]" @reset-data="fetchInvoiceEntry($event)" 
            :headers="headers"
            :items="entries || []"
            :show-menu-actions="true"
            @row-edited="updateEntry($event)"
            @row-added="addInvoiceEntry($event)" 
            @delete-item="deleteInvoiceEntry($event)"
            :right-click-menu-items="actionsList"
            :messagesSelectRowValidation="messagesSelectRowValidation"
            @nblur="handlBlurBoundTable"
            >
        </bee-smart-table>

        <!-- dialogReceipt -->
        <v-dialog v-model="dialogReceipt" width="600">
            <v-card>
                <v-card-title>
                    {{ $t('InvoiceSalePage.receivables') }}
                </v-card-title>
                <v-card-text>
                    <bee-handy-smart-table
                        ref="tableReceipt"
                        v-model="inputsReceipts"
                        :items="receipts"
                        :headers="headersReceipts"
                        :items-per-page="-1"
                        :data-table-props="{ disableSort: true }"
                        dense
                        zebra
                        hide-default-footer
                        :show-add-row="!submitLoading && !sale_invoice.is_posted && !isViewer"
                        hide-inputs-details
                        :editable-rows="!isViewer"
                        :loading="submitLoading"
                    >
                        <template v-slot:input.date="{ on, attr }">
                            <bee-date-input 
                                label=" "
                                fit-inputs
                                dense
                                input-format-order="DD-MM-YYYY"
                                v-on="on"
                                v-bind="attr"
                            />
                        </template>

                        <!-- no-input action -->
                        <template v-slot:no-input.actions>
                            <div class="d-flex justify-center">
                                <tooltip :text="$t('buttons.add')" top>
                                    <v-btn
                                        icon
                                        small
                                        color="greenDarken1"
                                        @click="confirmTotalReceiptForTotalNet()"
                                    >
                                        <v-icon>
                                            mdi-check-circle-outline
                                        </v-icon>
                                    </v-btn>
                                </tooltip>
                            </div>
                        </template>

                        <template v-if="!sale_invoice.is_posted && !isViewer" v-slot:item.actions="{ index, item }">
                            <div class="d-flex justify-center">
                                <v-btn
                                    icon
                                    small
                                    color="warning-color"
                                    @click="() => {
                                        transactionId = item.id;
                                        $refs.tableReceipt.activeEditForRow(index);
                                        editRowIndex = index;
                                        isEdit = true;
                                        $nextTick(() => {
                                            $refs.tableReceipt.resetInputsFocus()
                                        })
                                    }"
                                >
                                    <v-icon>
                                        mdi-pencil
                                    </v-icon>
                                </v-btn> 

                                <v-btn
                                    icon
                                    small
                                    color="deletingColor"
                                    @click="transactionId = item.id; deleteRowForReceipts()"
                                >
                                    <v-icon>
                                        mdi-delete
                                    </v-icon>
                                </v-btn>  
                            </div>
                            
                        </template>
                    </bee-handy-smart-table>
                </v-card-text>

                <v-card-actions class="pt-0">
                    <v-spacer />
                    <v-btn @click="dialogReceipt = false" color="greenDarken1" text>
                        {{ $t('buttons.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- alertMessageDialog -->
        <v-dialog v-model="alertMessageDialog" width="400">
            <v-card>
                <v-card-title>
                    {{ $t('InvoiceSalePage.alert-message') }}
                </v-card-title>

                <v-card-text>
                    {{ $t('InvoiceSalePage.confirm-message') }}
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer />
                    <v-btn @click="alertMessageDialog = false; !isEdit ? addRowForReceipts() : editRowForReceipts()" color="greenDarken1" text>
                        {{ $t('buttons.ok') }}
                    </v-btn>

                    <v-btn 
                        color="redDarken1" 
                        @click="
                            alertMessageDialog =  false;
                            $refs.tableReceipt.resetInputs({
                                date: moment().format('YYYY-MM-DD')
                            })
                        " 
                        text
                    >
                        {{ $t('buttons.cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-form v-model="valid" ref="form">
        <v-dialog transition="dialog-top-transition" v-model="addInvoiceDialog" max-width="500">
            <v-card>
            <v-card-title class="headline">
                {{$t('InvoiceSalePage.add-invoice')}}
            </v-card-title>
            <v-card-text>
            <v-row class="ma-0">
                <v-col cols="auto" lg="12" class="pa-0">
                    <bee-date-picker
                        context="invoice"
                        :action-name="actions.CREATE"
                        :label="$t('InvoiceSalePage.invoice-date')"
                        v-model="invoice_template.date"
                        :rules="[rules.date]"
                    ></bee-date-picker>
                </v-col>
                <v-col cols="auto" lg="9" class="py-0 d-flex flex-column">
                    <bee-account-autocomplete
                    context="invoice"
                    :action-name="actions.CREATE"
                    :hide-details="false" 
                    :rules="[rules.required]"
                    :label="$t('InvoiceSalePage.account')"
                    color="primary"
                    v-model="invoice_template.external_account_id"
                    :items="configs.accounts.filter(c=>c.type == 2)"
                    :with-balance="true"
                    ></bee-account-autocomplete>
                </v-col>
                <v-col cols="auto" lg="auto" class="py-0 ps-0">
                    <bee-text-field
                        context="invoice"
                        :action-name="actions.EDIT"
                        style="width: 100px !important"
                        :label="$t('InvoiceSalePage.document')"
                        :hide-details="false"
                        :rules="[rules.required]"
                        v-model="invoice_template.doc_no"
                    ></bee-text-field>
                </v-col>
                <v-col cols="auto" lg="12" class="py-0">
                    <bee-text-field context="invoice" :action-name="actions.EDIT" :label="$t('InvoiceSalePage.notes')" v-model="invoice_template.notes" :hide-details="true"></bee-text-field>
                </v-col>
            </v-row>
            </v-card-text>
            <v-card-actions class="ms-3">
                <v-btn
                    color="greenDarken1"
                    text
                    @click="create()"
                    :loading="loading"
                    :disabled="!valid || file_is_locked"
                >{{$t('InvoiceSalePage.create')}}</v-btn>
                <v-btn color="redDarken1" text @click="reSet()">{{$t('InvoiceSalePage.cancel')}}</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
            </v-card>
        </v-dialog>
        </v-form>
        <bee-dialog
            @handler="confirmDeleteInvoiceEntry()"
            @close="dialogDeleteEntry = false"
            v-model="dialogDeleteEntry"
            :title="$t('InvoiceSalePage.delete-entry')"
            :message="$t('InvoiceSalePage.are-you-sure-you-want-to-delete-the-entry')"
        ></bee-dialog>
        <bee-dialog
            @handler="deleteInvoice()"
            @close="dialogDeleteInvoice = false"
            v-model="dialogDeleteInvoice"
            :title="$t('InvoiceSalePage.delete-invoice')"
            :message="$t('InvoiceSalePage.are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond')"
        ></bee-dialog>
    </v-row>
    
    <v-bottom-navigation id="footer" height="auto" app horizontal class="px-3">
        <v-row class="fill-height ma-0" style="width: 100%" align="center">           
            <v-col
                v-if="useSaleInvoiceReceipts"
                cols="auto"
                lg="3"
                md="auto"
                sm="auto"
                xs="auto"
                class="align-center justify-start d-flex pe-lg-0"
            >
                <!-- receipts sum --> 
                {{ $t('InvoiceSalePage.total-receipts') + ': ' }}
                <span 
                    class="ms-2 me-4 font-weight-bold"
                    :class="{
                        'green--text': total_net === totalReceipt,
                        'red--text': total_net !== totalReceipt
                    }"
                > 
                    {{ (totalReceipt ? (totalReceipt).toLocaleString() : 0 ) }} 
                </span>
                <v-btn
                    :color="(!sale_invoice.is_posted && !isViewer ? 'success' : 'info-color') + ' white--text'"
                    class="px-0 rounded-xl" 
                    min-width="0"
                    width="28"
                    height="28"
                    @click="dialogReceipt = true" 
                >
                    <v-icon color="white" size="22" class="mx-0"> mdi-{{!sale_invoice.is_posted && !isViewer ? 'plus' : 'eye'}} </v-icon>  
                </v-btn>      
            </v-col>
            <v-col cols="auto" lg="4" md="auto" sm="auto" xs="auto" class="align-center justify-start d-flex pe-lg-0">
                <bee-text-field
                    :disabled="sale_invoice.is_posted || file_is_locked"
                    context="invoice"
                    :action-name="actions.EDIT"
                    @change="update()"
                    :label="$t('InvoiceSalePage.notes')"
                    v-model="sale_invoice.notes"
                    :hide-details="true"
                ></bee-text-field>
            </v-col>
            
            <v-spacer></v-spacer>
            <v-col  v-if="!isWarehousePermission" cols="auto" lg="auto" md="auto" sm="auto" xs="auto" class="align-center justify-start d-flex">
                <bee-money-field
                    context="invoice"
                    :disabled="!total || sale_invoice.is_posted || file_is_locked"
                    :action-name="actions.EDIT"
                    @blur="update()"
                    hide-details="true"
                    :label="$t('InvoiceSalePage.discount')"
                    v-model="sale_invoice.discount_total"
                    :rules="[rules.money]"
                ></bee-money-field>
            </v-col>

            <v-col  v-if="!isWarehousePermission" cols="auto" lg="auto" md="auto" sm="auto" xs="auto" class="align-start flex-column d-flex">
                <bee-outlined-header-info
                    :head="$t('InvoiceSalePage.total')"
                    border-color="transparent"
                    class="pa-lg-0"
                >
                    <template  v-slot:content="{}">
                        <bee-money-label :number="total" type="credit" :withColor="true" empty-state="_"></bee-money-label>
                    </template>
                </bee-outlined-header-info>
                <bee-outlined-header-info
                    :head="$t('InvoiceSalePage.net-invoice')"
                    border-color="transparent"
                    class="pa-lg-0"
                >
                    <template  v-slot:content="{}">
                        <bee-money-label :number="total_net" type="credit" :withColor="true" empty-state="_"></bee-money-label>
                    </template>
                </bee-outlined-header-info>
            </v-col>
        </v-row>
        </v-bottom-navigation>
    </div>
</div>
</template>
<script>
import rules from "../../../validation";
import actions from "../../../permissions/actions-names.js"
import { mapState, mapGetters } from "vuex";
import  store  from "../../../store/index.js";
import { invoiceEntryDetectedValidation } from "./helper/validation-detected-invoice-entry";
import { refactorRecord } from "./helper/operations-calculated-properties.js"
import EventBus from '../../../event-bus'
import ls from "@/settings/localStorageExtension";
import { userType, invoiceType, bondType, InvoicesTransactionType } from '@/helpers/enums'
import { multipleWarehouses, isMangeUnitAndRegionAndPatchAndLot, separationOfInvoices, useSaleInvoiceReceipts } from '@/configs/global'
import moment from 'moment';

export default {
data: () => 
    ({
        dialogDeleteInvoice: false,
        loading: false,
        valid: false,
        addInvoiceDialog: false,
        default_warehouse_id: null,
        selected_warehouse_id: null,
        invoice_no: null,
        ...rules,
        messagesSelectRowValidation: [],
        actions,
        invoice_template:{
            external_account_id: null,
            date: new Date().toISOString().substr(0, 10).toString(),
            doc_no: null,
            notes: null
        },
        linkedInvoiceRules: {
            price: true, quantity: true, count: true, material_id: true
        },
        entry: null,
        dialogDeleteEntry: false,

        updateInvoiceLoading: false,
        userType,
        invoiceType,
        multipleWarehouses,
        tableInputs: {},
        isMangeUnitAndRegionAndPatchAndLot,
        separationOfInvoices,
        useSaleInvoiceReceipts,
        dialogReceipt: false,
        inputsReceipts: {},
        receipts: [],
        editRowIndex: null,
        isEdit: false,
        InvoicesTransactionType,
        submitLoading: false,
        transactionId: null,
        totalReceipt: null,
        alertMessageDialog: false
    }),

    watch: {
        '$route.params.id'(val) {
            this.$refs.table.openLoading();
            this.$store.dispatch("invoices/fetch", {
                invoiceId: Number(val),
                invoiceType: invoiceType.sale 
            }).then((data) => {
                this.invoice_no = data.no
                this.changeWarehouse()
                this.$refs.table.onEsc(),
                this.$refs.table.closeLoading();
                this.totalReceipt = data.transactions.length ? data.transactions.map(c => c.amount?.amount).reduce((a, b) => a + b) : null
            })
        },
        dialogReceipt (val) {
            if(val) {
                this.inputsReceipts.date = moment().format('YYYY-MM-DD')
                this.getAllReceipts()
            } else {
                this.receipts = []
                this.transactionId = null
            }
        }
    },
computed: {
    ...mapState("configs" , ["configs"]),
    ...mapState("invoices" , ["sale_invoice"]),
    ...mapState("invoices" , ["simplified_sale_invoices"]),
    ...mapState("warehouses" , ["warehouses"]),
    ...mapState("materials" , ["materials"]),
    ...mapState({
        userTypePermission: state => state.permissions.user_type,
        currentFinancialFile: state => state.financialFiles.current_financial_file,
        numOfNotPostedInvoices: state => state.configs.configs.num_of_not_posted_invoices.filter(c => c.invoice_type === invoiceType.sale),
        numOfTotalSaleInvoices: state => state.configs.configs.num_of_total_invoices.filter(c => c.invoice_type === invoiceType.sale),
        warehousesForKeeper: state => state.warehouses.warehousesForKeeper
    }),
    ...mapGetters({
        isViewer: 'auth/isViewer'
    }),
    warehouse_materials(){
        return this.materials.filter(c=> this.selected_warehouse_id ? c.warehouse_id == this.selected_warehouse_id : true)
                    .filter(c=>c.type == 2)
    },
    file_is_locked(){ return this.configs?.financial_file?.is_locked },
    on_mdAndUp(){ return (this.$vuetify.breakpoint.mdAndUp) },
    addable(){
		return this.sale_invoice.is_posted || !this.invoice_no ? false : true
	},
    total(){ 
        return this.sale_invoice?.invoice_entries?.map(c=> c.calculated_total_amount?.amount ? c.calculated_total_amount.amount : 0 ).reduce((previousValue, currentValue) => previousValue + currentValue, 0) },
    on_lgAndUp(){ return(this.$vuetify.breakpoint.lgAndUp) },
    
    headers(){
        const headers = [
            {
                text: this.$t('InvoiceSalePage.headers.no'),
                value: 'no',
                type: 'string',
                width: !this.isWarehousePermission || !this.isMangeUnitAndRegionAndPatchAndLot ? '5%' : '19.5%',
                editable: false,
                settings: { context: 'invoice', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceSalePage.headers.warehouse'),
                value: 'warehouse_id',
                type: 'autocomplete',
                width: !this.isWarehousePermission || !this.isMangeUnitAndRegionAndPatchAndLot ? '16%' : '19.5%',
                editable: true,
                required: true,
                settings: { itemText: 'name', items: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? this.warehousesForKeeper : this.warehouses, clearable: true, itemValue: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id' , context: 'warehouses', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceSalePage.headers.material'),
                value: 'material_id',
                type: 'materials-autocomplete',
                width: '20%',
                editable: true, rules:[this.linkedInvoiceRules.material_id],
                settings: {itemText: undefined, items: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? this.materials.filter(c => c.warehouse_id === this.tableInputs.warehouse && c.type === 2) : this.materials.filter(c => c.type === 2), subItems: this.warehouse_materials }
            },
            {
                text: this.$t('InvoiceSalePage.headers.quantity'),
                value: 'quantity',
                type: 'numeric',
                width: !this.isWarehousePermission || !this.isMangeUnitAndRegionAndPatchAndLot  ? '10%' : '12.5%',
                editable: true, rules:[this.linkedInvoiceRules.quantity],
                settings: { context: 'invoice', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceSalePage.headers.count'),
                value: 'count',
                type: 'numeric',
                width: !this.isWarehousePermission || !this.isMangeUnitAndRegionAndPatchAndLot  ? '6%' : '19.5%',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceSalePage.headers.notes'),
                value: 'notes',
                type: 'string',
                width: !this.isWarehousePermission || !this.isMangeUnitAndRegionAndPatchAndLot  ? '15%' : '19.5%',
                editable: true, required: true,
                settings: { context: 'invoice', actionName: actions.GET } 
            },
            {
                text: '',
                value: 'hint',
                type: 'hint',
                width: !this.isWarehousePermission ? '2%' : '1',
                editable: false
            },
        ]
        if(isMangeUnitAndRegionAndPatchAndLot) {
            headers.splice(6,0, 
            {
                text: 'رقم الباتش',
                name: 'patchNumber',
                value: 'patchNumber',
                type: 'string',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET },
                width: '10%'
            },
            {
                text: 'رقم اللوت',
                name: 'lotNumber',
                value: 'lotNumber',
                type: 'string',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET },
                width: '10%'
            },
            {
                text: 'تاريخ الانتهاء',
                name: 'endDate',
                value: 'endDate',
                type: 'date',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET },
                width: '10%'
            })
        }
        if(!this.isWarehousePermission) { 
            headers.splice(4, 0, 
            {
                text: this.$t('InvoiceSalePage.headers.price'),
                value: 'price',
                type: 'numeric',
                width: '10%',
                editable: true, rules:[this.rules.money && this.linkedInvoiceRules.price],
                settings: { context: 'invoice', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceSalePage.headers.discount-percentage'),
                value: 'discount_percentage',
                type: 'numeric',
                width: this.$emerald.ifLang('es', '140px', '6%'),
                editable: true,
                settings: { prefix: '%' }
            },
			{
                text: this.$t('InvoiceSalePage.headers.discount'),
                value: 'discount_amount',
                type: 'numeric',
                width: '10%',
                editable: true
            },
            {
                text: this.$t('InvoiceSalePage.headers.after-discount'),
                value: 'calculated_total_amount',
                type: 'numeric',
                width: '10%',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET }
            },
        )
        }
        return headers
    },

    isWarehousePermission() {
        return (this.userTypePermission === userType.warehouseKeeper && separationOfInvoices) || (this.userTypePermission === userType.warehouseManger && separationOfInvoices)
    },

    entries(){
        return this.sale_invoice.invoice_entries?.map(c=> ({ no: c.no, 
            warehouse_id: this.materials.find(x=>x.id == c.material_id)?.warehouse_id, 
            id: c.id,
            material_id: c.material_id,
            quantity: c.quantity?.quantity,
            count: c.count,
            price: c.price?.amount,
            calculated_total_amount: c.calculated_total_amount?.amount,
            notes: c.notes,
            type: c.type,
            discount_percentage: c.discount_percentage ? c.discount_percentage : 0,
            discount_amount: c.discount_amount?.amount
        }))
    },
    total_net() { 
        return this.sale_invoice.discount_total?.amount 
            ? this.total - this.sale_invoice.discount_total.amount : this.total 
    },
    actionsList(){
        return [
            {
                name: 'edit',
                disabled: this.sale_invoice.is_posted,
                action_name: actions.EDIT,
                text: this.$t('InvoiceSalePage.context-menu.edit')
            },
            {
                name: 'delete-item',
                disabled: this.sale_invoice.is_posted,
                action_name: actions.DELETE,
                text: this.$t('InvoiceSalePage.context-menu.delete')
            }
        ]
    },

    bond_posting_ratio() {
        return this.numOfTotalSaleInvoices.length
            ? 100 -
            ((this.numOfNotPostedInvoices.length ? this.numOfNotPostedInvoices[0].count : 0) * 100) /
                this.numOfTotalSaleInvoices[0].count
        : 100   
    },

    bond_posting_ratio_tooltip() {
        return this.numOfNotPostedInvoices.length
            ? `${this.numOfNotPostedInvoices[0].count} ${this.$t('unposted-invoices')}`
            : this.$t('unposted-invoices');
    },
    bond_posting_ratio_caption() {
        return `${this.numOfNotPostedInvoices.length ? this.numOfNotPostedInvoices[0].count : 0}/${this.numOfTotalSaleInvoices.length ? this.numOfTotalSaleInvoices[0].count : 0}`;
    },

    headersReceipts() {
        return [
            {
                text: this.$t('headers.date'),
                value: 'date',
                name: 'date'
            },
            {
                text: this.$t('headers.amount'),
                name: 'amount',
                value: 'amount.amount',
                type: 'number'
            },
            {
                text: this.$t('headers.note'),
                name: 'notes',
                value: 'notes',
                width: '40%'
            },
            {
                text: '',
                name: 'actions',
                value: 'actions',
                noNotAvailableText: true,
                noInput: true
            }
        ]
    }

},
methods:{
    create(){
        this.loading = true
		store.dispatch("invoices/create",{ invoiceType: invoiceType.sale, invoice: this.invoice_template })
		.then(() => { 
            this.invoice_no = this.sale_invoice.no 
            this.updateRouteId()
		})
		.finally(() => this.reSet());
    },
    updateRouteId(){
		var invoice = this.simplified_sale_invoices?.find(c => c.no === this.invoice_no)
		if (invoice && invoice.id !== Number(this.$route.params.id)){
			this.$router.push({name: 'invoices-sale', params:{ id: invoice.id }})
		}
    },
    unPosting(){ 
        this.updateInvoiceLoading = true;
        store.dispatch("invoices/updateToNotPosted", { invoiceId:this.sale_invoice.id, invoiceType: invoiceType.sale })
        .then(()=>{
			Promise.all([
                store.dispatch("materialsJournals/fetchAll", { fromDate: this.configs.financial_file.start_date, toDate: new Date().toISOString().substr(0, 10) }),
                store.dispatch("configs/fetchAll"), 
                store.dispatch("invoices/fetch", { invoiceId:this.sale_invoice.id, invoiceType: invoiceType.sale }), 
                store.dispatch("bonds/fetchAll", { bondType: bondType.accounting }) 
            ]).finally(() => {
                this.updateInvoiceLoading = false;
            })
        }).catch(() => {
            this.updateInvoiceLoading = false;
        })
    },
    posting(){
        this.updateInvoiceLoading = true;
        store.dispatch("invoices/updateToPosted", { invoiceId:this.sale_invoice.id, invoiceType: invoiceType.sale })
        .then(()=>{
            Promise.all([
                store.dispatch("materialsJournals/fetchAll", { fromDate: this.configs.financial_file.start_date, toDate: new Date().toISOString().substr(0, 10) }),
                store.dispatch("configs/fetchAll"), 
                store.dispatch("invoices/fetch", { invoiceId:this.sale_invoice.id, invoiceType: invoiceType.sale }), 
                store.dispatch("bonds/fetchAll", { bondType: bondType.accounting }) 
            ]).finally(() => {
                this.updateInvoiceLoading = false;
            })
        }).catch(() => {
            this.updateInvoiceLoading = false;
        })
    },
    handlBlurBoundTable(invoiceEntry) {
        this.messagesSelectRowValidation = invoiceEntryDetectedValidation(invoiceEntry, this.linkedInvoiceRules, { price: this.isWarehousePermission });
    },
    fetchInvoiceEntry(invoiceEntry){
        store.dispatch("invoices/fetchEntry",{ id: invoiceEntry.id, invoiceType: invoiceType.sale })
    },
    updateEntry(invoiceEntry){        
        let entry = refactorRecord(this.entries[invoiceEntry.rowIndex], this.configs.financial_file.default_currency_id)
        entry.invoice_id = this.sale_invoice.id
        if(this.$refs.table.$refs.table.$refs.table.valids[`valid_${invoiceEntry.rowIndex}`])
            store.dispatch("invoices/updateEntry", {
                invoiceId: this.sale_invoice.id,
                invoiceType: invoiceType.sale,
                invoiceEntry: { 
                ...entry,
                price: entry.price ? entry.price : {
                    amount:  0,
                    currency_id: this.currentFinancialFile.default_currency_id
                },
                calculated_total_amount: entry.calculated_total_amount ? entry.calculated_total_amount : {
                    amount:  0,
                    currency_id: this.currentFinancialFile.default_currency_id
                }
            }	
            })
            .then(() => { 
                store.dispatch("invoices/fetch", { invoiceId: this.sale_invoice.id, invoiceType: invoiceType.sale })
                invoiceEntry.deleteRowIndex()
            })
            .finally(()=>{
                invoiceEntry.connectionEnded(1, "BeeAutocomplete")
            })
        else
            EventBus.$emit('error', 'تأكد من صحة البيانات المدخلة')
    },
    addInvoiceEntry(invoiceEntry){
        let entry = refactorRecord(invoiceEntry.value, this.configs.financial_file.default_currency_id)
        entry.invoice_id = this.sale_invoice.id
        entry.type = invoiceType.sale
        if (!entry.id) { delete entry.id; }
        store.dispatch("invoices/createEntry", {
			invoiceId: this.sale_invoice.id,
			invoiceType: invoiceType.sale,
			invoiceEntry: { 
                ...entry,
                price: entry.price ? entry.price : {
                    amount:  0,
                    currency_id: this.currentFinancialFile.default_currency_id
                } ,
                calculated_total_amount: entry.calculated_total_amount ? entry.calculated_total_amount : {
                    amount:  0,
                    currency_id: this.currentFinancialFile.default_currency_id
                }
            }		
        })
        .then(() => {
            store.dispatch("invoices/fetch", { invoiceId: this.sale_invoice.id, invoiceType: invoiceType.sale })
            invoiceEntry.deleteRowData({ warehouse_id: this.selected_warehouse_id })
        }).finally(()=>{
            invoiceEntry.connectionEnded(1, "BeeAutocomplete")
        })
    },
    deleteInvoiceEntry(invoiceEntry){
		this.entry = {...invoiceEntry}
		this.dialogDeleteEntry = true
    },
	confirmDeleteInvoiceEntry(){
		store.dispatch("invoices/deleteEntry", { invoiceId: this.sale_invoice.id, invoiceType: invoiceType.sale, invoiceEntryId: this.entry.id }).then(()=>{
			store.dispatch("invoices/fetch", { invoiceId: this.sale_invoice.id, invoiceType: invoiceType.sale })
		}).finally(()=>{
			this.entry = null
		})
	},
    update(){
        let invoice = {
            external_account_id : this.sale_invoice.external_account_id,
            date: this.sale_invoice.date,
            doc_no: this.sale_invoice.doc_no,
        }
        let required = false
        Object.keys(invoice).forEach((key) => { if(!invoice[key]) required = true; return })

        invoice.total_net = { amount: this.total_net, currency_id: this.configs.financial_file.default_currency_id }
        invoice.notes =  this.sale_invoice.notes
        invoice.discount_total = this.sale_invoice.discount_total

        if(!required && this.sale_invoice.discount_total.amount <= this.total)
            store.dispatch("invoices/update",{ invoiceId: this.sale_invoice.id, invoiceType: invoiceType.sale, invoice })
            .then(() => { 
                this.$store.dispatch("invoices/fetch", {
                    invoiceId: Number(this.$route.params.id),
                    invoiceType: invoiceType.sale 
                }).then((data) => {
                    this.invoice_no = data.no
                    this.changeWarehouse()
                    this.$refs.table.onEsc(),
                    this.$refs.table.closeLoading();
                })
                EventBus.$emit("notification", "تم تحديث بيانات الفاتورة");
            })
        else
            EventBus.$emit('error', 'تأكد من صحة البيانات المدخلة')
    },
    changeWarehouse(){
        EventBus.$emit('initialize-last-row', { warehouse_id: this.default_warehouse_id })
        this.selected_warehouse_id = this.default_warehouse_id
    },
    reSet(){
        this.loading = false
        this.invoice_template.external_account_id = null
        this.invoice_template.doc_no = null
        this.invoice_template.notes = null
        this.invoice_template.date = new Date().toISOString().substr(0, 10).toString()
        this.addInvoiceDialog = false
        this.$refs.form.resetValidation()
    },
    deleteInvoice(){
        store.dispatch("invoices/delete", { invoiceId:this.sale_invoice.id, invoiceType: invoiceType.sale })
            .then(()=>{ 
                Promise.all([store.dispatch("configs/fetchAll"), store.dispatch("invoices/fetchAll", invoiceType.sale),
                    store.dispatch("bonds/fetchAll", { bondType: bondType.accounting })
                ]).then(()=>{
                    if(this.simplified_sale_invoices.length > 0){
                        this.invoice_no = this.simplified_sale_invoices[this.simplified_sale_invoices.length -1].no
                        this.updateRouteId()
                    }
                    else
                        this.$router.push({ name: 'invoices-sale' })
                            .then(()=> this.$router.go(0) /** Force refresh to empty the store*/ )
                    })
            })
    },

    confirmTotalReceiptForTotalNet() {
        if (
           (((this.totalReceipt + this.inputsReceipts.amount) > this.total_net) && !this.isEdit)
        ) {
            this.alertMessageDialog = true
        } else if(
            (    
                ((this.totalReceipt - this.receipts[this.editRowIndex].amount.amount + this.inputsReceipts.amount) > this.total_net) && 
                this.isEdit
            )
        ) {
            this.alertMessageDialog = true
        }
         else {
            if(!this.isEdit) {
                this.addRowForReceipts()
            } else {
                this.editRowForReceipts()
            }
        }
    },

    addRowForReceipts() {
        this.submitLoading = true
        const entryData =  {
            invoice_id: this.sale_invoice.id,
            date: this.inputsReceipts.date,
            amount: {
                amount: this.inputsReceipts.amount,
                currency_id: this.currentFinancialFile.default_currency_id
            },
            type: InvoicesTransactionType.receipt,
            notes: this.inputsReceipts.notes
        }
        this.$store.dispatch('transactions/create', {   
            entryData,
            invoiceType: invoiceType.sale, 
            invoiceId: this.sale_invoice.id 
        }).then(() => {
            this.getAllReceipts()
        })
        this.$refs.tableReceipt.resetInputs({
            date: moment().format('YYYY-MM-DD')
        })
    },

    editRowForReceipts() {
        this.submitLoading = true
        const entryData =  {
            invoice_id: this.sale_invoice.id,
            date: this.inputsReceipts.date,
            amount: {
                amount: this.inputsReceipts.amount,
                currency_id: this.currentFinancialFile.default_currency_id
            },
            type: InvoicesTransactionType.receipt,
            notes: this.inputsReceipts.notes
        }
        this.$store.dispatch('transactions/update', {   
            entryData,
            transactionId: this.transactionId, 
            invoiceId: this.sale_invoice.id,
            invoiceType: invoiceType.sale
        }).then(() => {
       
            this.getAllReceipts()
        }).finally(() => {
            this.$refs.tableReceipt.resetEdit();
            this.isEdit = false;
        })
        this.$nextTick(() => {
            this.$refs.tableReceipt.resetInputs({
                date: moment().format('YYYY-MM-DD')
            })
            this.$refs.tableReceipt.resetInputsFocus()
        })
    },

    deleteRowForReceipts() {
        this.submitLoading = true
        this.$store.dispatch('transactions/delete', { transactionId: this.transactionId }).then(() => {
            this.getAllReceipts()
        }).finally(() => {
            this.submitLoading = false
            this.transactionId = null
        })
    },

    getAllReceipts() {
        this.submitLoading = true
        this.$store.dispatch('transactions/fetchTransaction', { 
            invoiceType: invoiceType.sale, 
            invoiceId: this.sale_invoice.id,
            transactionType: InvoicesTransactionType.receipt
        }).then((data) => {
            this.receipts = data.data
            this.totalReceipt = this.receipts.length ? this.receipts.map(c => c.amount?.amount).reduce((a, b) => a + b) : null
            this.submitLoading = false
        }).finally(() => {
            this.submitLoading = false
        })
    },

    getReport(type) {
        this.$store.dispatch('reports/invoice', {
            type,
            financialFileId: this.currentFinancialFile.id,
            userId: ls.getLocalUser().id,
            invoiceType: invoiceType.sale,
            invoiceId: this.sale_invoice.id,
        })
    }
},

mounted(){
    window.observer.observe(document.querySelector("#tool-bar"));
    window.observer.observe(document.querySelector("#footer"));
    EventBus.$on('warehouse-changed', (warehouse_id, material_id = null)=>{ 
        if(!warehouse_id && material_id)
        {
            // تحديث قائمة مواد المستودع
            this.selected_warehouse_id = this.materials.find(c=>c.id == material_id)?.warehouse_id
            // تعيين المستودع التابع للمادة
            EventBus.$emit('initialize-last-row', { warehouse_id: this.selected_warehouse_id })
        }    
        else
            this.selected_warehouse_id =  warehouse_id
    });

    this.default_warehouse_id = this.configs.warehouse.id
    this.selected_warehouse_id = this.default_warehouse_id
    EventBus.$emit('initialize-last-row', { warehouse_id: this.selected_warehouse_id }) 

    // inits routes and store
    const promises = [
        this.$store.dispatch('warehouses/fetchAll'),
        this.$store.dispatch('materials/fetchAll'),
        this.$store.dispatch('invoices/fetchAll', invoiceType.sale)
    ];
	if(Object.keys(this.configs).length == 0) {
        promises.push(this.$store.dispatch('configs/fetchAll'))
    }

    if(this.$route.params.id) {
        promises.push(
            this.$store.dispatch("invoices/fetch", {
                invoiceId: Number(this.$route.params.id),
                invoiceType: invoiceType.sale
            }).then((data) => {
                this.invoice_no = data.no
                this.changeWarehouse()
                this.$refs.table.onEsc(),
                this.$refs.table.closeLoading();
                this.totalReceipt = data.transactions.length ? data.transactions.map(c => c.amount?.amount).reduce((a, b) => a + b) : null
            })
        )
    } else {
        Promise.all(promises)
            .then(()=> {
                if(this.simplified_sale_invoices.length > 0) {
                    this.$router.replace({
                        name: 'invoices-sale',
                        params: { id: this.simplified_sale_invoices[this.simplified_sale_invoices.length -1].id }
                    })
                }
            });
    }

    // this.$refs.table.openLoading();
},

/*
async beforeRouteEnterSS(to, from, next) {
	let promises = [store.dispatch("warehouses/fetchAll"), store.dispatch("materials/fetchAll"), store.dispatch("invoices/fetchAll", "Sale")]
	let object = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(object).length == 0)
		promises.push(store.dispatch("configs/fetchAll"))

	if(promises.length)
		await Promise.all(promises)

    if(to.params.id)
	{
		if(to.name != 'invoice-sale')
			next({name: 'invoice-sale', params:{id: to.params.id}})
	}	
	else
	{
		let sale_invoices = JSON.parse(JSON.stringify(store.state.invoices.simplified_sale_invoices))
		if(sale_invoices.length > 0)
			next({ name: 'invoice-sale', params:{id: sale_invoices[sale_invoices.length -1].id }})
	}

	next(
		vm => {
			if(to.name == 'invoice-sale')
			{
				if(to.params.id)
				{
					vm.$refs.table.openLoading();
					store.dispatch("invoices/fetch", { invoiceId: Number(to.params.id), invoiceType:"Sale" })
						.then(response=> { 
							vm.invoice_no = response.no
							vm.changeWarehouse()
							vm.$refs.table.onEsc(),
							vm.$refs.table.closeLoading();})
				}
			} 
		})
}
*/
}
</script>
<style>
.my-border {
	border: 1px solid !important;
	border-color: #f1f1f1 !important;	
}
.v-bottom-navigation {
	overflow-y: unset;
	box-shadow: 0px 10px 5px #eee, 0px -2px 5px gainsboro !important;
	background: linear-gradient(180deg, rgba(241,241,241,1) 0%, rgba(230,240,245,1) 100%);
}
.fill-height
{
height: 100% !important;
}
</style>
